let $ = window.jQuery;
let mainNav = null;

function onDocumentReady(){
    $('.mobile-nav-toggle').on('click', onClickMobileNavToggle);
    mainNav = $('#main-nav');
}

function onClickMobileNavToggle(e){
    mainNav.slideToggle();
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
